import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { ContractDetailPanelData } from 'components/contract-detail-panel/types';
import {
  ToBeProcessedFilters,
  CreateServiceDateRequest,
  PatchServiceDateRequest,
  PaginatedResponse,
  ToBeProcessedItem,
  BulkConfirmServiceDatesRequest,
  BulkConfirmServiceDatesErrorItem,
} from 'modules/contract-processing/types';

export const getToBeProcessed = async (
  filters: ToBeProcessedFilters,
  companyId: number,
): Promise<PaginatedResponse<ToBeProcessedItem>> => {
  const response: AxiosResponse<PaginatedResponse<ToBeProcessedItem>> = await getApi().post(
    'ContractProcessing/GetToBeProcessed',
    filters,
    {
      headers: { companyId },
    },
  );
  return response.data;
};

export const createServiceDate = async (
  request: CreateServiceDateRequest,
  companyId: number,
): Promise<ToBeProcessedItem> => {
  const response: AxiosResponse<ToBeProcessedItem> = await getApi().post(
    'ContractProcessing/CreateServiceDate',
    request,
    {
      headers: { companyId },
    },
  );
  return response.data;
};

export const patchServiceDate = async (
  id: number,
  request: PatchServiceDateRequest,
  companyId: number,
): Promise<ToBeProcessedItem> => {
  const response: AxiosResponse<ToBeProcessedItem> = await getApi().patch(
    `ContractProcessing/ServiceDate/${id}`,
    request,
    { headers: { companyId } },
  );
  return response.data;
};

export const getContractDateDetail = async (
  contractDateId: number,
  companyId: number,
): Promise<ContractDetailPanelData> => {
  const response: AxiosResponse<ContractDetailPanelData> = await getApi().get(
    `ContractProcessing/GetContractDateDetail/${contractDateId}`,
    { headers: { companyId } },
  );
  return response.data;
};

export const bulkConfirmServiceDates = async (
  request: BulkConfirmServiceDatesRequest,
  companyId: number,
): Promise<BulkConfirmServiceDatesErrorItem[]> => {
  const response: AxiosResponse<BulkConfirmServiceDatesErrorItem[]> = await getApi().post(
    'ContractProcessing/BulkConfirmServiceDates',
    request,
    { headers: { companyId } },
  );
  return response.data;
};
